@if (showBox) {
  <div #box class="tutorialBox" [@removeAnimation] (@removeAnimation.done)="removeBox()">
    <button class="tutorialBox__button" (click)="onToggle()">
      <p class="tutorialBox__title" slot="start">
        {{ titleText | tmd | stripTags }}
      </p>
      @if (!removeOnDismiss) {
        <img slot="end" [src]="icon" [@rotateAnimation]="open ? 'up' : 'down'" />
      }
      @if (removeOnDismiss) {
        <img slot="end" [src]="icon" (click)="dismiss()" />
      }
    </button>
    @if (open) {
      <div #openBox [@toggleAnimation] (@toggleAnimation.done)="animationDone()">
        <div class="tutorialBox__content">
          <div class="tutorialBox__body">
            <ng-content />
          </div>
        </div>
      </div>
    }
  </div>
}
